module.exports = __webpack_public_path__ + "img/q10.f5bf5a1b.jpg";